/**
 * Default controller for Site Admin
 *
 * @class Controller
 * @depends jquery.actionController.js
 * @author Mihai Curelea
 */

var $ = require('jquery');
var Modernizr = require('Modernizr');
var Window = require('./window');
var siteadmin = require('./siteadmin');

var Controller = function () {

    var self = this;

    this.disabledCache = false;

    var saWindow = null;
    /* Site Admin window */
    var params = null;
    /* params received when loading this controller */
    var SAC = null;
    /* Site Admin Content for the opened IFrame content */

    /* the cache store is used to store json payloads
     coming from the server, so that the second times won't be
     fetched */
    var cacheStore = {};
    /* which controllers should be cached. usually the ones with static data */
    var cacheControllers = ['layoutSelector', 'theming'];

    /* removes a controller from the cache */
    this.clearCache = function (controllerName) {
        if (controllerName in cacheStore) {
            delete cacheStore[controllerName];
        }
    };

    this.getControllerName = function () {
        if (params) {
            return params.controller;
        }
        return null;
    };

    this.getWindow = function () {
        return saWindow;
    };

    this.destroy = function () {
        saWindow.destroy();
    };

    this.disableCache = function () {
        this.disabledCache = true;
    };

    this.init = function () {
        /* init the Site Admin Window */
        saWindow = new Window(this);
        saWindow.init();

        /* init site admin help button */
        try {
            parseHelpLinks();
        } catch (e) {
        }

        $(document).bind('diy-siteadmin-external-ready', function (e, callback) {
            saWindow.loadingBox.hide();
            self.keepalive.refresh();

            if ('function' === typeof callback) {
                try {
                    callback(diy.editor.siteadmin.api);
                }
                catch (exception) {
                    // ...
                }
            }
        });
    };

    this.updateHelpTopic = function (topic) {
        saWindow.updateHelpTopic(topic);
    };

    this.updateFeatureGuidanceHelp = function (stepId) {
        saWindow.updateFeatureGuidanceHelp(stepId);
    };

    /**
     * sends unload event to the SAC inside the iframe
     */
    this.unloadSAC = function () {
        try {
            if (SAC) {
                SAC.$wnd.trigger('unload');
                SAC = null;
            }
        } catch (e) {
        }
        // clear all content
        //$('#cc-sa-window-content').empty();
    };

    /**
     * resize the SAC inside the iframe based on the window size
     */
    this.resizeSAC = function () {
        try {
            var cw = saWindow.getContentWrapper();
            if (SAC && cw.width() > 0 && cw.height() > 0) {
                SAC.resize({
                    height: cw.height(),
                    width: cw.width()
                });
            }
        } catch (e) {
        }
    };

    /**
     * close whatever this controller opened
     */
    this.close = function (preventDefaultCloseAll, skipCacheCheck) {
        if (jQuery.browser.msie) {
            // Bugfix #DHDIYW-874 - On IE11, when switching between two siteadmin
            // sections, if the previous one had a focused input, you can no longer
            // focus/edit anything in the new one. The cause is unknown, but this
            // hack seems so fix the problem, by manually "resetting" the focus
            // We use a dummy text input (it doesn't work with other types of
            // elements) and we put it with position fixed, otherwise the browser
            // will scroll the page when focusing
            jQuery('<input type="text" style="position:fixed;top:0;left:0"/>')
                .appendTo('body')
                .focus()
                .remove();
        }
        saWindow.close();
        this.unloadSAC();
        if (skipCacheCheck !== true && this.disabledCache === true) {
            // destroy the controller without calling the close method on it *again*
            siteadmin.destroyController(
                siteadmin.getActiveControllerId(),
                false
            );
        }
        if (preventDefaultCloseAll !== true) {
            /* also add close hash */
            var currentHash = window.top.location.hash;
            if ('#close-all' !== currentHash) {
                var loc = window.top.location,
                    href = loc.protocol + '//';
                href += loc.host;
                href += loc.pathname;
                href += loc.search;
                href += '#hm:cc-sa-window-close';
                window.top.location.href = href;
            }

            if (diy.editor.uiPreference.isPointerModeTouch()) {
                diy.editor.siteadmin.api.toggleSidebar(false);
            }
        }
    };

    this.load = function (o) {
        /* make sure SAC is unloaded before */
        this.unloadSAC();

        saWindow.headerData = {};
        saWindow.footerData = {};

        params = o;

        params.contentType = params.contentType || 'iframe-local';

        if (params.hasOwnProperty('windowBehavior')) {
            this.attachWindowBehavior(params.windowBehavior);
        }

        if (params.hasOwnProperty('originalWindowBehavior')) {
            try {
                var originalWindowBehavior = $.parseJSON(params.originalWindowBehavior);
                saWindow.originalWindowBehavior = originalWindowBehavior;
            } catch (e) {
            }
        }

        saWindow.setContentType(params.contentType);

        /* set the controller name to the window */
        saWindow.setAttribute(params.controller);
    };

    /**
     * extracted method from this.load
     * @param behavior
     */
    this.attachWindowBehavior = function (behavior) {
        var windowBehaviorObj = null;
        try {
            windowBehaviorObj = $.parseJSON(behavior || 'null');
        } catch (e) {
        }


        if (windowBehaviorObj !== null && windowBehaviorObj.hasOwnProperty('size')) {
            var view_port = $(window).height();
            windowBehaviorObj.size.height = Math.min(windowBehaviorObj.size.height, view_port);
            params.windowBehavior = JSON.stringify(windowBehaviorObj);
        }

        if (windowBehaviorObj !== null &&
            windowBehaviorObj.hasOwnProperty('cacheWindow') &&
            windowBehaviorObj.cacheWindow === false) {
            this.disabledCache = true;
        }
        saWindow.setBehavior(params.windowBehavior);
    };

    this.unload = function (obj, data) {
        if (params && params.controller && diy.editor.siteadmin.controllers[params.controller] && 'function' === typeof diy.editor.siteadmin.controllers[params.controller].unload) {
            diy.editor.siteadmin.controllers[params.controller].unload(obj, data);
        }

        params = null;
    };

    this.onSacReady = function (e, wnd) {
        if (siteadmin.getActiveControllerId() !== saWindow.getID() && !saWindow.isOpened()) {
            //ready event triggered when another window is opened
            //@todo: figure another way to do this without braking SA tab switching
            //return;
        }

        /* copy needed data inside the iframe */
        $.extend(wnd, {
            CC: CC,
            jimdoData: jimdoData
        });

        /* add history plugins */
        wnd.jQuery.fn.historyManager = $.fn.historyManager;
        wnd.jQuery.fn.history = $.fn.history;

        /* init constructors inside the iframe */
        wnd.jQuery.construct('*', 'create');

        /* set local SAC variable to the current controller inside the iframe */
        SAC = wnd.SAC;

        /* resize the SAC */
        self.resizeSAC();

        /* initialize help system */
        SAC.bindHelpLinkClick();

        /* resize the window */
        saWindow.resize();
    };

    this.show = function (dst) {
        saWindow.show();
        if (!dst) {
            this.setContent(params.element);
        }
    };

    this.allowHide = function () {
        var activeController = siteadmin.getController(),
            controllerName = null, controller, allowHide = true;
        //get from the current controller if it allows the switch
        if (activeController) {
            controllerName = activeController.getControllerName();
        }
        //if the prev controller allows swithcing away
        if (controllerName) {
            controller = diy.editor.siteadmin.controllers[controllerName];
            if (controller &&
                controller.hasOwnProperty('allowSwitch')
            ) {
                allowHide = controller.allowSwitch();
            }
        }
        return allowHide;
    };

    this.hide = function () {
        saWindow.hide();
    };

    this.unbindEvent = function() {
        $(document).unbind('diy-siteadmin-sac-ready', this.onSacReady);
    };

    this.bindEvent = function() {
        this.unbindEvent();
        $(document).bind('diy-siteadmin-sac-ready', this.onSacReady);
    };

    this.setContent = function (el) {
//        clearContent();
        fillContent(el);
    };

    this.isOpened = function () {
        return saWindow.isOpened();
    };

    this.getWindow = function () {
        return saWindow;
    };
    this.getMinMaxState = function () {
        var state = 'max';
        if (this.isOpened()) {
            state = saWindow.getMinMaxState();
        }
        return state;
    };

    this.loading = function (sw) {
        saWindow.loading(sw);
    };
    this.smallLoading = function (sw, bottomDistance, rightDistance) {
        saWindow.smallLoading(sw, bottomDistance, rightDistance);
    };

    var fillContent = function (el) {
        saWindow.clearContent();
        var contentElement = saWindow.getContentElement();

        // show either the loadingBox or the regular loader, to prevent loader stacking/overlapping
        if (saWindow.loadingBox && saWindow.loadingBox.isUsed) {
            saWindow.loadingBox.show();
        }
        else {
            self.loading('show');
        }

        var readyHandler = function () {
            $(document).trigger('diy-siteadmin-content-loaded', [params]);
            parseHelpLinks();
            self.loading('hide');
        };

        /**
         * initializes inline content
         * @param data
         */
        var loadInline = function (data) {
            /* fill the content element with the received data */
            if ('string' === typeof data) {
                html = data;
            } else if ('object' === typeof data && data.html) {
                html = data.html;
            } else if ('object' === typeof data && 'object' === typeof data.data && data.data.html) {
                html = data.data.html;
            }
            contentElement.html(html);

            /* if there are further actions to be taken, take them */
            if (params.controller && diy.editor.siteadmin.controllers[params.controller]) {
                diy.editor.siteadmin.api.updateFeatureGuidanceHelp();
                diy.editor.siteadmin.controllers[params.controller].afterFillContent(el, data, contentElement);

                /*
                 * Trigger the ready handler only when the final content has fully loaded
                 */
                if ("theming" === params.controller) {

                    $(document).bind("diy-editor-theming-styleWindowLoaded", readyHandler);

                    /*
                     * Resize and hide loading indicator; hidding the loading indicator is necessary due to the fact
                     * that in some cases (like for the styles panel) the readyHandler call is deferred until the final
                     * paylod is delivered.
                     */
                    saWindow.resize();
                    self.loading('hide');

                    //early return: readyHandler has been deferred asynchronously
                    return;

                }
            }

            saWindow.resize();
            readyHandler();
        };

        if ('iframe-local' === params.contentType) {
            /* notify iframe content loaded */
            contentElement.one('load', function (e) {
                readyHandler();
            });

            /* set the url to the iframe */
            contentElement.attr('src', el.href);
        } else if ('inline' === params.contentType) {
            /* ajax request to the url */
            var html = '';
            var data;
            /* if cached content is in store, load it from there */
            if (self.getControllerName() && cacheStore[self.getControllerName()]) {
                /* keep reference, so any modified data in a previous session is still available */
                data = cacheStore[self.getControllerName()];
                loadInline(data);
            } else {
                /* if content not cached, request from server */
                $.get(el.href, function (data) {
                    /* only cache if we are allowed to cache the current controller */
                    if (cacheControllers.indexOf(self.getControllerName()) > -1) {
                        /* keep reference, so any modified data in a previous session is still available */
                        cacheStore[self.getControllerName()] = data;
                    }
                    loadInline(data);
                });
            }
        } else if ('iframe-external' === params.contentType) {
            /* notify iframe content loaded */
            contentElement.one('load', function (e) {
                $(document).trigger('diy-siteadmin-content-loaded', [params]);
                self.loading('hide');
            });
            /* set the url to the iframe */
            contentElement.attr('src', el.href);
        } else if ('delegated' === params.contentType) {
            if (params.controller && diy.editor.siteadmin.controllers[params.controller]) {
                diy.editor.siteadmin.controllers[params.controller]
                    .fillContent(contentElement, readyHandler);
            }
        }

    };

    var parseHelpLinks = function () {
        // @TODO: These methods will throw an exception when accessing iframes with external content. Fix this by
        // first clearing the content of each area before loading new content.
        cms.help.GuidedAssistant.getInstance()._initSiteAdminButton(cms.help.GuidedAssistant.options.siteAdminButtonId);
        cms.help.GuidedAssistant.getInstance()._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);
    };

    this.updateID = function (id) {
        saWindow.updateID(id);
    };
    this.updateTitle = function (title) {
        saWindow.updateTitle(title);
        saWindow.resize();
    };
    this.updateDescr = function (descr) {
        saWindow.updateDescr(descr);
        saWindow.resize();
    };
    // they should be here //
    /*
     * id
     * text
     * url
     * icon
     * disabled
     * windowBehavior
     * contentType
     */
    this.updateNavi = function (navi) {
        saWindow.updateNavi(navi);
        saWindow.resize();
    };

    /**
     * Shows the top navigation including tabs
     */
    this.showNavi = function () {
        saWindow.showNavi();
        saWindow.resize();
    };

    /**
     * Hides the top navigation including tabs
     */
    this.hideNavi = function () {
        saWindow.hideNavi();
    };

    this.setNaviActiveItem = function (id) {
        saWindow.setNaviActiveItem(id);
    };

    this.updateSaveBtn = function (btn, callback) {
        saWindow.updateSaveBtn(btn, callback);
    };

    this.saveBtnClicked = function (a, b, c) {
        saWindow.saveBtnClicked(a, b, c);
    };

    var clearContent = function () {
        saWindow.clearContent();
    };

    this.getHeaderData = function () {
        return saWindow.headerData;
    };

    this.updateButtons = function (buttons) {
        saWindow.updateButtons(buttons);
    };

    this.keepalive = (function () {
        var settings = {
            refreshInterval: 1800, // refresh time in seconds
            callbackUrl: '/app/default/index/keepalive'
        };
        return {
            lastCalled: null,
            getTime: function () {
                var d = new Date();
                return Math.round(d.getTime() / 1000); // time in seconds
            },
            callback: function () {
                this.lastCalled = this.getTime();
                $.ajax({url: settings.callbackUrl, method: "POST"});
            },
            reset: function () {
                this.lastCalled = null;
            },
            refresh: function () {
                var now = this.getTime();
                if (this.lastCalled === null) {
                    this.lastCalled = now;
                    return;
                }
                if (now - this.lastCalled >= settings.refreshInterval) {
                    return this.callback();
                }
            }
        };
    }());

    return this;

};

module.exports = Controller;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/controller.js
 ** module id = 23
 ** module chunks = 0
 **/